module.exports = __webpack_public_path__ + "static/img/shl_wechat_qrcode.895951f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_wechat_qrcode.jpg
// module id = jTFw
// module chunks = 5